import { render, staticRenderFns } from "./ClientAjouter.vue?vue&type=template&id=267d938d&"
import script from "./ClientAjouter.vue?vue&type=script&lang=js&"
export * from "./ClientAjouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports